import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="main-container politika" style={{ padding: "20px" }}>
      <h1>Politika privatnosti</h1>
      <p>
        Vaša privatnost nam je od izuzetne važnosti. Ova Politika privatnosti
        objašnjava kako prikupljamo, koristimo i štitimo vaše lične podatke kada
        koristite našu veb stranicu{" "}
        <a
          href="https://www.unijana.rs"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.unijana.rs
        </a>.
      </p>

      <h2>1. Prikupljanje podataka</h2>
      <p>
        Kada posetite našu veb stranicu, možemo prikupljati sledeće informacije:
      </p>
      <ul>
        <li>
          <strong>Lični podaci</strong>: Ime, prezime, email adresa, broj
          telefona i druge informacije koje dobrovoljno pružate putem kontakt
          forme ili prilikom registracije.
        </li>
        <li>
          <strong>Tehnički podaci</strong>: IP adresa, tip pregledača,
          operativni sistem, vreme pristupa i stranice koje posećujete.
        </li>
      </ul>

      <h2>2. Korišćenje podataka</h2>
      <p>Prikupljene podatke koristimo za:</p>
      <ul>
        <li>Odgovaranje na vaše upite i pružanje traženih informacija.</li>
        <li>Poboljšanje funkcionalnosti i sadržaja naše veb stranice.</li>
        <li>
          Slanje obaveštenja o našim uslugama, promocijama ili događajima,
          ukoliko ste dali saglasnost za to.
        </li>
      </ul>

      <h2>3. Kolačići (Cookies)</h2>
      <p>
        Naša veb stranica koristi kolačiće za poboljšanje korisničkog iskustva.
        Kolačići su male tekstualne datoteke koje se čuvaju na vašem uređaju.
        Možete podesiti svoj pregledač da odbije kolačiće ili da vas obavesti
        kada se kolačići šalju. Međutim, imajte na umu da neke funkcije veb
        stranice možda neće raditi ispravno bez kolačića.
      </p>

      <h2>4. Deljenje podataka</h2>
      <p>
        Vaše lične podatke ne delimo sa trećim stranama, osim u sledećim
        slučajevima:
      </p>
      <ul>
        <li>Kada imamo vašu izričitu saglasnost.</li>
        <li>Kada je to neophodno radi ispunjenja zakonskih obaveza.</li>
        <li>Kada je to potrebno za zaštitu naših prava ili bezbednosti.</li>
      </ul>

      <h2>5. Sigurnost podataka</h2>
      <p>
        Preduzimamo odgovarajuće tehničke i organizacione mere kako bismo
        zaštitili vaše lične podatke od neovlašćenog pristupa, gubitka ili
        zloupotrebe.
      </p>

      <h2>6. Vaša prava</h2>
      <p>U skladu sa važećim zakonima o zaštiti podataka, imate pravo da:</p>
      <ul>
        <li>Zatražite pristup svojim ličnim podacima.</li>
        <li>Zatražite ispravku netačnih ili nepotpunih podataka.</li>
        <li>Zatražite brisanje svojih podataka.</li>
        <li>Ograničite ili prigovorite na obradu svojih podataka.</li>
        <li>Prenesete svoje podatke drugom rukovaocu.</li>
      </ul>
      <p>
        Za ostvarivanje ovih prava, kontaktirajte nas putem email adrese
        navedene u nastavku.
      </p>

      <h2>7. Izmene Politike privatnosti</h2>
      <p>
        Zadržavamo pravo da povremeno ažuriramo ovu Politiku privatnosti. Sve
        izmene će biti objavljene na ovoj stranici, uz naznačen datum poslednje
        izmene.
      </p>

      <h2>Kontakt</h2>
      <p>
        Za sva pitanja ili zahteve u vezi sa vašim ličnim podacima, molimo vas
        da nas kontaktirate na:
      </p>
      <p>
        <strong>Email</strong>:{" "}
        <a href="mailto:sladjanaijana16@gmail.com">sladjanaijana16@gmail.com</a>
      </p>
      <p>
        <strong>Telefon</strong>: <a href="tel:0631833253">0631833253</a>
      </p>

      <p>
        Hvala što koristite našu veb stranicu i što nam verujete u pogledu
        zaštite vaše privatnosti.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
